/***********************
 * Theme switch
 ************************/

import React, { useState } from "react"
import PropTypes from "prop-types"
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap"
import { Tooltip } from "antd"
import { withTranslation } from "react-i18next"
import themes from "common/themes"
import { get, map } from "lodash"
import { useTheme } from "contexts/ThemeProvider"

const ThemeDropdown = props => {
  const { theme, toggleTheme } = useTheme()
  const [menu, setMenu] = useState(false)

  const toggle = () => {
    setMenu(!menu)
  }

  return (
    <>
      <Dropdown
        isOpen={menu}
        toggle={toggle}
        className="d-inline-block"
        tag="li"
      >
        <Tooltip title={props.t("Theme")} trigger={["hover", "focus"]}>
          <DropdownToggle
            aria-haspopup="menu"
            aria-label={props.t("Theme")}
            tag="button"
            className="btn header-item noti-icon focus-topbar"
          >
            <i id="" className="bx bx-palette align-middle" />
          </DropdownToggle>{" "}
        </Tooltip>
        <DropdownMenu className="dropdown-menu ">
          {map(Object.keys(themes), key => (
            <DropdownItem
              key={key}
              onClick={() => toggleTheme(key)}
              className={`notify-item ${theme === key ? "active" : "none"}`}
            >
              {/* <img
                src={get(themes, `${key}.icon`)}
                alt="Theme"
                className="me-2"
                height="12"
              /> */}
              {get(themes, `${key}.label`) == "ThemeLight" ? (
                <i className="bx bx-sun ms-0 me-2 font-size-14"></i>
              ) : (
                <i className="bx bx-moon ms-0 me-2 font-size-14"></i>
              )}
              {/* <i className="bx bx-sun ms-0 me-2 font-size-14"></i> */}
              <span className="align-middle">
                {props.t(get(themes, `${key}.label`))}
              </span>
            </DropdownItem>
          ))}
        </DropdownMenu>
      </Dropdown>
    </>
  )
}

ThemeDropdown.propTypes = {
  t: PropTypes.any,
}

export default withTranslation()(ThemeDropdown)
